import gql from 'graphql-tag'

export const GET_REQUEST_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $from: SystemType!
  ) {
    getRequestPaginated (
      data: {
        from: $from
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        name
        answered
      }
    }
  }
`

export const GET_REQUEST_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getRequest (
      data: {
        id: $id
      }
    ) {
      id
      name
      telNumber
      message
      from
      answered
    }
  }
`
